//获取当前时间 format=1精确到天 format=2精确到分 格式：2020-06-22 22:43:24
const fGetNowTime = (format = 2, yyyymmdd) => {
  var now = new Date();
  var year = now.getFullYear(); //得到年份
  var month = now.getMonth(); //得到月份
  var date = now.getDate(); //得到日期
  var day = now.getDay(); //得到周几
  var hour = now.getHours(); //得到小时
  var minu = now.getMinutes(); //得到分钟
  var sec = now.getSeconds(); //得到秒
  month = month + 1;
  if (month < 10) month = "0" + month;
  if (date < 10) date = "0" + date;
  if (hour < 10) hour = "0" + hour;
  if (minu < 10) minu = "0" + minu;
  if (sec < 10) sec = "0" + sec;
  var time = "";
  //精确到天
  if (format == 1) {
    time = year + "-" + month + "-" + date;
  }
  //日期格式
  if (format == 1 && yyyymmdd == 'YYYYMMDD') {
    time = year + month + date;
  }
  //精确到分
  if (format == 2) {
    time = year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
  }
  return time;
}

//与当前时间比较大小，得出它的天数
const fTime2NowDay = (value) => {
  var that_time = Date.parse(fGetNowTime(2)); //获取当前时间，并转成时间戳
  var updata_time = Date.parse(value); //你输入的时间，格式：2020-06-20 18:31:30
  //两者相差的天数
  var num_day = (that_time - updata_time) / (1000 * 60 * 60 * 24);
  return num_day
};

//将时间戳转换成正常时间
// var date_time = Date.parse("2020-06-20 18:31:30");//转为时间戳
// console.log(timestampToTime(date_time));//2020-06-20 18:31:30
const fTimestampToTime = (timestamp) => {
  var date = ""
  if (timestamp.length == 13) {
    date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  } else {
    date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  }
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = date.getDate() + ' ';
  var h = date.getHours() + ':';
  var m = date.getMinutes() + ':';
  var s = date.getSeconds();
  return Y + M + D + h + m + s;
}

//获取前后几天 console.log(getDate("-30"));
function timeAdd0(str) {
  if (str.length <= 1) {
    str = '0' + str;
  }
  return str
}
const fGetQhDay = (days) => {
  //定义今日标准时间;
  var d = new Date();
  var nowYear = d.getFullYear().toString(); //今年
  var nowMonth = timeAdd0((d.getMonth() + 1).toString()); //当月
  var nowDay = timeAdd0(d.getDate().toString()); //当日
  var now = nowYear + "-" + nowMonth + "-" + nowDay; //今日标准时间; 2020-09-02

  //日期计算;
  var startDate = new Date(Date.parse(now.replace(/-/g, '/'))); //将开始时间由字符串格式转换为日期格式
  var value = startDate.getTime(); //将开始时间转为毫秒
  value += days * (24 * 3600 * 1000); //将天数转换成毫秒后与开始时间相加得到结束时间的毫秒数
  var d2 = new Date(value); //将得到的毫秒数转换为日期
  var nowYear2 = d2.getFullYear().toString(); //今年
  var nowMonth2 = timeAdd0((d2.getMonth() + 1).toString()); //当月
  var nowDay2 = timeAdd0(d2.getDate().toString()); //当日
  var endDate = nowYear2 + "-" + nowMonth2 + "-" + nowDay2;
  return endDate;
};


// 获取多少天前的日期
// val: 要获取 val 天前的日期
// digit: = 3 时 返回 年月日  ///  = 6 时 返回 年月日时分秒
const manyDaysAgo = (value = 0, digit = 3) => {

  // 获取当前时间 的 年月日
  let date = new Date()
  // let year = date.getFullYear();
  // let month = date.getMonth() + 1;
  // let day = date.getDate();

  let t = date.getTime() - (parseInt(value) * 24 * 60 * 60 * 1000)
  // 获得七天前的时间戳
  let val = new Date(t)
  let t1_year = val.getFullYear()
  let t1_month = val.getMonth() + 1
  let t1_day = val.getDate()
	let t1_hours = val.getHours()
	let t1_m = val.getMinutes()
	let t1_s = val.getSeconds()
  if (t1_month < 10) {
    t1_month = '0' + t1_month
  }
  if (t1_day < 10) {
    t1_day = '0' + t1_day
  }
  if (digit == 3) {
    return t1_year + '-' + t1_month + '-' + t1_day
  }
  if (digit == 6) {
    return t1_year + '-' + t1_month + '-' + t1_day + ' ' + t1_hours + ':' + t1_m + ':' + t1_s
  }
}

// 获取多少天后的日期
// val: 要获取 val 天后的日期
// digit: = 3 时 返回 年月日  ///  = 6 时 返回 年月日时分秒
const manyDaysLater = (value = 0, digit = 3) => {

  // 获取当前时间 的 年月日
  let date = new Date()
  // let year = date.getFullYear();
  // let month = date.getMonth() + 1;
  // let day = date.getDate();

  let t = date.getTime() + (parseInt(value) * 24 * 60 * 60 * 1000)
  let val = new Date(t)
  let t1_year = val.getFullYear()
  let t1_month = val.getMonth() + 1
  let t1_day = val.getDate()
  let t1_hours = val.getHours()
  let t1_m = val.getMinutes()
  let t1_s = val.getSeconds()
  if (t1_month < 10) {
    t1_month = '0' + t1_month
  }
  if (t1_day < 10) {
    t1_day = '0' + t1_day
  }
  if (t1_hours < 10) {
    t1_hours = '0' + t1_hours
  }
  if (t1_m < 10) {
    t1_m = '0' + t1_m
  }
  if (t1_s < 10) {
    t1_s = '0' + t1_s
  }
  if (digit == 3) {
    return t1_year + '-' + t1_month + '-' + t1_day
  }
  if (digit == 6) {
    return t1_year + '-' + t1_month + '-' + t1_day + ' ' + t1_hours + ':' + t1_m + ':' + t1_s
  }
}

/**
 * 获取本周、本季度、本月、上月的开始日期、结束日期
 */
var now = new Date(); //当前日期
var nowDayOfWeek = now.getDay(); //今天本周的第几天
var nowDay = now.getDate(); //当前日
var nowMonth = now.getMonth(); //当前月
var nowYear = now.getYear(); //当前年
nowYear += (nowYear < 2000) ? 1900 : 0; //
var lastMonthDate = new Date(); //上月日期
lastMonthDate.setDate(1);
lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
var lastYear = lastMonthDate.getYear();
var lastMonth = lastMonthDate.getMonth();
//格式化日期：yyyy-MM-dd
function formatDate(date) {
  var myyear = date.getFullYear();
  var mymonth = date.getMonth() + 1;
  var myweekday = date.getDate();
  if (mymonth < 10) {
    mymonth = "0" + mymonth;
  }
  if (myweekday < 10) {
    myweekday = "0" + myweekday;
  }
  return (myyear + "-" + mymonth + "-" + myweekday);
}
//获得某月的天数
function getMonthDays(myMonth) {
  var monthStartDate = new Date(nowYear, myMonth, 1);
  var monthEndDate = new Date(nowYear, myMonth + 1, 1);
  var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
  return days;
}
//获得本季度的开始月份
function getQuarterStartMonth() {
  var quarterStartMonth = 0;
  if (nowMonth < 3) {
    quarterStartMonth = 0;
  }
  if (2 < nowMonth && nowMonth < 6) {
    quarterStartMonth = 3;
  }
  if (5 < nowMonth && nowMonth < 9) {
    quarterStartMonth = 6;
  }
  if (nowMonth > 8) {
    quarterStartMonth = 9;
  }
  return quarterStartMonth;
}
//获得本周的开始日期
function getWeekStartDate() {
  var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
  return formatDate(weekStartDate);
}
//获得本周的结束日期
function getWeekEndDate() {
  var weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));
  return formatDate(weekEndDate);
}
//获得上周的开始日期
function getLastWeekStartDate() {
  var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 6);
  return formatDate(weekStartDate);
}
//获得上周的结束日期
function getLastWeekEndDate() {
  var weekEndDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
  return formatDate(weekEndDate);
}
//获得本月的开始日期
function getMonthStartDate() {
  var monthStartDate = new Date(nowYear, nowMonth, 1);
  return formatDate(monthStartDate);
}
//获得本月的结束日期
function getMonthEndDate() {
  var monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth));
  return formatDate(monthEndDate);
}
//获得上月开始时间
function getLastMonthStartDate() {
  var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
  return formatDate(lastMonthStartDate);
}
//获得上月结束时间
function getLastMonthEndDate() {
  var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
  return formatDate(lastMonthEndDate);
}

//日期格式化函数
const fDateFat = (fmt, date) => {
  if (date == null || date == '' || date == 'undefined') {
    return '';
  }
  date = date + '';
  date = date.replace(/\-/g, "/");
  if (date.indexOf('GMT') == -1) {
    date = date.replace(/\T/g, " ");
  }
  if (date.indexOf('.') != -1) {
    date = date.substr(0, date.indexOf('.'));
  }
  date = new Date(date);
  fmt = fmt || "yyyy-MM-dd hh:mm:ss";
  var o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "q+": Math.floor((date.getMonth() + 3) / 3),
    "S": date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
//fDateTimeFat 时间格式化
const fDateTimeFat = (date, format) => {
  if (date.length == 8) {
    date = date.replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3")
  }
  if (!date) return;
  if (!format) format = "yyyy-MM-dd";
  switch (typeof date) {
    case "string":
      date = new Date(date.replace(/-/, "/"));
      break;
    case "number":
      date = new Date(date);
      break;
  }
  if (!date instanceof Date) return;
  var dict = {
    "yyyy": date.getFullYear(),
    "M": date.getMonth() + 1,
    "d": date.getDate(),
    "H": date.getHours(),
    "m": date.getMinutes(),
    "s": date.getSeconds(),
    "MM": ("" + (date.getMonth() + 101)).substr(1),
    "dd": ("" + (date.getDate() + 100)).substr(1),
    "HH": ("" + (date.getHours() + 100)).substr(1),
    "mm": ("" + (date.getMinutes() + 100)).substr(1),
    "ss": ("" + (date.getSeconds() + 100)).substr(1)
  };
  return format.replace(/(yyyy|MM?|dd?|HH?|ss?|mm?)/g, function() {
    return dict[arguments[0]];
  });
}

function getCurrentTime() { //241102115101123
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const day = now.getDate().toString().padStart(2, '0');
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');
  const milliseconds = now.getMilliseconds().toString().padEnd(3, '0');

  return `${year.toString().slice(2)}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
}


export default {
  fGetNowTime, //获取当前时间 format=1精确到天 format=2精确到分
  fTime2NowDay, //与当前时间比较大小，得出它的天数
  fTimestampToTime, //将时间戳转换成正常时间
  fGetQhDay, //获取前后几天
  manyDaysAgo, // 获取多少天前的日期
  manyDaysLater, // 获取多少天后的日期
  getLastWeekStartDate, //获得上周的开始日期
  getLastWeekEndDate, //获得上周的结束日期
  getMonthStartDate, //获得本月的开始日期
  getMonthEndDate, //获得本月的结束日期
  getLastMonthStartDate, //获得上月开始时间
  getLastMonthEndDate, //获得上月结束时间
  fDateFat, //时间格式化
  fDateTimeFat, //时间格式化
  getCurrentTime, //获取当前时间 241102115101123格式
}



//////////////////
// WEBPACK FOOTER
// ./common/global/timeHelper.js
// module id = FI14
// module chunks = 210